const codeLocationInput = {
  /**
   * Initialize the events and variables
   * @param  {String} group Name of the current group
   * @return {void}
   */
  create(node) {
    this.group = node;

    this.list = this.getElementForGroup('.js-list-input__list');
    this.listItems = this.getElementsForGroup('.js-list-input__list-item');
    this.add = this.getElementForGroup('.js-list-input__control-add');
    this.deleteButtons = this.getElementsForGroup('.js-list-input__list-item-delete');

    if (!this.listItems.length) {
      this.addListItem();
    }

    this.add.addEventListener('click', () => {
      this.addListItem();
    });

    this.deleteButtons.forEach(deleteButton => this.addEventListenerToDeleteButton(deleteButton));
  },

  addListItem() {
    const listItemIndex = this.generateListItemIndex();

    const listItemWrapper = document.createElement('div');
    const listItemNameInput = document.createElement('input');
    const listItemIsJobtransInputWrapper = document.createElement('div');
    const listItemIsJobtransInput = document.createElement('input');
    const listItemIsJobtransLabel = document.createElement('label');
    const listItemDelete = document.createElement('button');

    listItemWrapper.classList = 'js-list-input__list-item';

    listItemNameInput.setAttribute('name', `code95[location_options][${listItemIndex}][name]`);
    listItemNameInput.setAttribute('id', `code95[location_options][${listItemIndex}][name]`);
    listItemNameInput.setAttribute('type', 'text');
    listItemNameInput.classList = 'form-control form-control-sm w-50';

    listItemIsJobtransInputWrapper.classList = 'form-check pl-1 pt-1';
    listItemIsJobtransInput.setAttribute('type', 'checkbox');
    listItemIsJobtransInput.setAttribute('value', '1');
    listItemIsJobtransInput.setAttribute('name', `code95[location_options][${listItemIndex}][is_jobtrans]`);
    listItemIsJobtransInput.setAttribute('id', `code95[location_options][${listItemIndex}][is_jobtrans]`);
    listItemIsJobtransInput.style = 'margin-right: 8px;';

    listItemIsJobtransLabel.setAttribute('for', `code95[location_options][${listItemIndex}][is_jobtrans]`);
    listItemIsJobtransLabel.innerText = 'JobTrans locatie';

    listItemIsJobtransInputWrapper.appendChild(listItemIsJobtransInput);
    listItemIsJobtransInputWrapper.appendChild(listItemIsJobtransLabel);

    listItemDelete.setAttribute('type', 'button');
    listItemDelete.classList = 'js-list-input__list-item-delete btn btn-sm btn-danger';
    listItemDelete.innerText = 'x';

    this.addEventListenerToDeleteButton(listItemDelete);

    listItemWrapper.appendChild(listItemNameInput);
    listItemWrapper.appendChild(listItemIsJobtransInputWrapper);
    listItemWrapper.appendChild(listItemDelete);

    this.list.appendChild(listItemWrapper);
  },

  addEventListenerToDeleteButton(button) {
    button.addEventListener('click', (e) => {
      e.target.parentElement.remove();
    });
  },

  generateListItemIndex() {
    const listItems = this.getElementsForGroup('.js-list-input__list-item');
    const lastItem = listItems[listItems.length - 1];

    if (lastItem === undefined) {
      return listItems.length;
    }

    return parseInt(lastItem.dataset.listItemIndex, 0) + 1;
  },

  /**
   * Get element from the same group with a classname
   * @param  {String} cls Class name to get the element for
   * @return {Node}       Element
   */
  getElementForGroup(cls) {
    return this.group.querySelector(cls);
  },

  /**
   * Get elements from the same group with a classname
   * @param  {String} cls Class name to get the element for
   * @return {Node}       Element
   */
  getElementsForGroup(cls) {
    return this.group.querySelectorAll(cls);
  },
};

export default codeLocationInput;
